import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, combineLatest, filter, map, pairwise, startWith, tap } from 'rxjs';
import { Locale } from 'src/app/models/internationalization/internationalization-models';
import { SelectItem } from 'src/app/select/select.component';
import { SystemService } from 'src/app/system/system.service';
import { UserService } from 'src/app/user/user.service';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-language-form',
    templateUrl: './language-form.component.html',
    styleUrls: ['./language-form.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, MatFormField, MatSelect, MatOption, AsyncPipe]
})
export class LanguageFormComponent {
	private readonly _systemService = inject(SystemService);
	private readonly _userService = inject(UserService);
	private readonly _translateService = inject(TranslocoService);


	data$!: Observable<{ locales: Locale[], selectedLocale: Locale, items: SelectItem[], selectedItem: SelectItem } | null>;

	readonly form = new FormGroup({
		localeId: new FormControl<number | null>(null, [Validators.required])
	});

	constructor() {
		const _systemService = this._systemService;
		const _userService = this._userService;


		this.data$ = combineLatest([
			_systemService.locales$,
			_userService.basicInfo$
		]).pipe(
			map(([locales, user]) => ({ locales, user })),
			filter(v => v.user != null && v.locales != null),
			map(v => {
				const localeId = v.user!.localeId ?? 1;
				const items = v.locales!.map(i => ({ id: i.id, value: i.nativeName.substring(0, 3) }));
				const selectedItem = items.find(i => i.id == localeId)!;
				const selectedLocale = v.locales!.find(i => i.id == localeId)!;
				return {
					locales: v.locales!,
					selectedLocale,
					items,
					selectedItem
				};
			}),
			tap(v => {
				if (!v) {
					return;
				}
				this.form.controls.localeId.setValue(v.selectedLocale.id);
			})
		);

		this.form.controls.localeId.valueChanges.pipe(
			untilDestroyed(this),
			filter(v => this.form.controls.localeId.dirty)
		).subscribe(localeId => {
			this._userService.updateUserLocale({ localeId: localeId! }).subscribe(v => {
				window.location.reload();
				/* const locale = this._systemService.locales$.getValue()!.find(i => i.id == localeId);
				_translateService.setActiveLang(locale!.languageCode); */
			});
		});
	}
}
